module.exports = __webpack_public_path__ + "img/be-care-fo.ad307a5d.png";